export const SIDEBAR_MENU_STEP = [
  // { link: "/candidate/profile/dashboard", name: "Dashboard" },
  { link: "/candidate/detail/", name: "View Profile" },
  { link: "/candidate/personal/", name: "Edit Profile" },
]

export const COMPANY_SIDEBAR_MENU_STEP = [
  // { link: "/company/profile/dashboard", name: "Dashboard" },
  { link: "/company/detail/", name: "View Profile" },
  { link: "/company/company-detail", name: "Edit Profile" },
]

export const COMPANY_JOB_MENU = [
  // { link: "/candidate/profile/dashboard", name: "Dashboard" },
  { link: "/jobs/post-job/", name: "Post a Job" },
  { link: "/jobs", name: "Posted Jobs" },
  // { link: "/candidate/jobs/drafts/", name: "Draft Jobs" },
  // { link: "/candidate/jobs/expired/", name: "Expired Jobs" },
]

export const CANDIDATE_JOB_MENU = [
  { link: "/jobs", name: "Jobs" },
  // { link: "/candidate/profile/dashboard", name: "Dashboard" },
  // { link: "/job", name: "Find a Job" },
  // { link: "/candidate/jobs/", name: "Recommended" },
  // { link: "/candidate/jobs/drafts/", name: "Applied" },
  // { link: "/candidate/jobs/expired/", name: "Shortlisted" },
  // { link: "/candidate/jobs/expired/", name: "Saved" },
]
